module.exports = __webpack_public_path__ + "img/progress-bar-danger.svg?b61fa449d74f326c1800311bcb11f2b6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pages/img/progress/progress-bar-danger.svg
// module id = 269
// module chunks = 0